import { lazy } from "react";
import type { FeatureRoute } from "../../app/route-types";

/** Ekip, kişiler (rehber), bildirimler ve İK izin yönetimi. Yollar: docs/UX.md §2. */
export const routes: FeatureRoute[] = [
  { path: "ekibim", Component: lazy(() => import("./TeamPage")) },
  { path: "kisiler", Component: lazy(() => import("./PeoplePage")) },
  { path: "kisiler/:id", Component: lazy(() => import("./PersonPage")) },
  { path: "bildirimler", Component: lazy(() => import("./NotificationsPage")) },
  { path: "ik/izin", Component: lazy(() => import("./HrLeavePage")) },
];
